/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_attributes_stability = /** @type {(inputs: {}) => string} */ () => {
	return `Stabilita`
};

const da_attributes_stability = /** @type {(inputs: {}) => string} */ () => {
	return `Stability`
};

const de_attributes_stability = /** @type {(inputs: {}) => string} */ () => {
	return `Stabilität`
};

const en_attributes_stability = /** @type {(inputs: {}) => string} */ () => {
	return `Stability`
};

const es_attributes_stability = /** @type {(inputs: {}) => string} */ () => {
	return `Estabilidad`
};

const fr_attributes_stability = /** @type {(inputs: {}) => string} */ () => {
	return `Stabilité`
};

const hu_attributes_stability = /** @type {(inputs: {}) => string} */ () => {
	return `Stabilitás`
};

const it_attributes_stability = /** @type {(inputs: {}) => string} */ () => {
	return `Stabilità`
};

const nl_attributes_stability = /** @type {(inputs: {}) => string} */ () => {
	return `Stabiliteit`
};

const pl_attributes_stability = /** @type {(inputs: {}) => string} */ () => {
	return `Stabilność`
};

const pt_attributes_stability = /** @type {(inputs: {}) => string} */ () => {
	return `Estabilidade`
};

const sv_attributes_stability = /** @type {(inputs: {}) => string} */ () => {
	return `Stabilitet`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const attributes_stability = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.attributes_stability(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("attributes_stability", locale)
	if (locale === "cs") return cs_attributes_stability(inputs)
	if (locale === "da") return da_attributes_stability(inputs)
	if (locale === "de") return de_attributes_stability(inputs)
	if (locale === "en") return en_attributes_stability(inputs)
	if (locale === "es") return es_attributes_stability(inputs)
	if (locale === "fr") return fr_attributes_stability(inputs)
	if (locale === "hu") return hu_attributes_stability(inputs)
	if (locale === "it") return it_attributes_stability(inputs)
	if (locale === "nl") return nl_attributes_stability(inputs)
	if (locale === "pl") return pl_attributes_stability(inputs)
	if (locale === "pt") return pt_attributes_stability(inputs)
	return sv_attributes_stability(inputs)
};
export { attributes_stability as "attributes.stability" }